import { css } from 'lit';
export default css `
  :host {
    display: inline-block;
    position: relative;
    line-height: 1;
  }

  sl-button {
    width: 100%;
  }

  sl-button::part(base) {
    --sl-input-height-medium: 40px;
    --sl-input-border-width: 0;
    --sl-input-border-radius-medium: var(--amityeko-radius-small);
  }

  sl-button.amityeko-has-prefix::part(base) {
    padding: 0 0 0 20px;
  }

  sl-button.amityeko-has-suffix::part(base) {
    padding: 0 20px 0 0;
  }

  sl-button[disabled]::part(base) {
    opacity: 1;
  }

  sl-button::part(prefix) {
    --amityeko-icon-size: 12px;
  }

  sl-button::part(suffix) {
    --amityeko-icon-size: 12px;
  }

  sl-button::part(label) {
    padding: 0 20px;
  }

  sl-button.amityeko-has-prefix::part(label) {
    padding: 0 20px 0 12px;
  }

  sl-button.amityeko-has-suffix::part(label) {
    padding: 0 12px 0 20px;
  }

  sl-button[circle]::part(base) {
    width: var(--amityeko-circle-button-size, 24px);
    height: var(--amityeko-circle-button-size, 24px);
    align-items: center;
  }

  sl-button[circle]::part(label) {
    padding: 0;
  }

  sl-button amityeko-tg-label-two::part(base) {
    line-height: 40px;
  }

  /* Variant: primary */
  sl-button[variant='primary']::part(base) {
    --amityeko-icon-color: var(--amityeko-color-font-light);
    background-color: var(--private-bg-color, var(--amityeko-color-primary-6));
    color: var(--amityeko-color-font-light);
  }

  sl-button[variant='primary']::part(base):hover {
    background-color: var(--private-bg-color-hover, var(--amityeko-color-primary-7));
  }

  sl-button[variant='primary']::part(base):active {
    background-color: var(--private-bg-color-active, var(--amityeko-color-primary-8));
  }

  sl-button[variant='primary'][disabled]::part(base) {
    background-color: var(--private-bg-color-disabled, var(--amityeko-color-primary-3));
  }

  /* Variant: secondary (as sl text) */
  sl-button[variant='text'].amityeko-variant-secondary::part(base) {
    --amityeko-icon-color: var(--private-color, var(--amityeko-color-gray-1));
    color: var(--private-color, var(--amityeko-color-gray-1));
    border: 1px solid var(--private-bg-color-hover, var(--amityeko-color-gray-8));
  }

  sl-button[variant='text'].amityeko-variant-secondary:not([disabled])::part(base):hover {
    --amityeko-icon-color: var(--private-color-hover, var(--amityeko-color-gray-1));
    color: var(--private-color-hover, var(--amityeko-color-gray-1));
    background-color: var(--private-bg-color-hover, var(--amityeko-color-gray-8));
  }

  sl-button[variant='text'].amityeko-variant-secondary:not([disabled])::part(base):active {
    --amityeko-icon-color: var(--private-color-active, var(--amityeko-color-gray-1));
    color: var(--private-color-active, var(--amityeko-color-gray-1));
    background-color: var(--private-bg-color-active, var(--amityeko-color-gray-7));
  }

  sl-button[variant='text'].amityeko-variant-secondary[disabled]::part(base) {
    --amityeko-icon-color: var(--private-color-disabled, var(--amityeko-color-gray-7));
    color: var(--private-color-disabled, var(--amityeko-color-gray-7));
  }

  /* Variant: ghost (as sl text) */
  sl-button[variant='text'].amityeko-variant-ghost::part(base) {
    --amityeko-icon-color: var(--private-color, var(--amityeko-color-gray-3));
    color: var(--private-color, var(--amityeko-color-gray-3));
  }

  sl-button[variant='text'].amityeko-variant-ghost:not([disabled])::part(base):hover {
    --amityeko-icon-color: var(--private-color-hover, var(--amityeko-color-gray-1));
    color: var(--private-color-hover, var(--amityeko-color-gray-1));
    background-color: var(--private-bg-color-hover, var(--amityeko-color-gray-8));
  }

  sl-button[variant='text'].amityeko-variant-ghost:not([disabled])::part(base):active {
    --amityeko-icon-color: var(--private-color-active, var(--amityeko-color-gray-1));
    color: var(--private-color-active, var(--amityeko-color-gray-1));
    background-color: var(--private-bg-color-active, var(--amityeko-color-gray-7));
  }

  sl-button[variant='text'].amityeko-variant-ghost[disabled]::part(base) {
    --amityeko-icon-color: var(--private-color-disabled, var(--amityeko-color-gray-7));
    color: var(--private-color-disabled, var(--amityeko-color-gray-7));
  }

  /* Variant: floating (as sl text) */
  sl-button[variant='text'].amityeko-variant-floating::part(base) {
    --amityeko-icon-color: var(--private-color, var(--amityeko-color-gray-6));
    color: var(--private-color, var(--amityeko-color-gray-6));
    background-color: var(--amityeko-color-font-light);
    box-shadow: var(--amityeko-elevation-3);
  }

  sl-button[variant='text'].amityeko-variant-floating:not([disabled])::part(base):hover {
    background-color: var(--private-bg-color-hover, var(--amityeko-color-gray-9));
  }

  sl-button[variant='text'].amityeko-variant-floating:not([disabled])::part(base):active {
    background-color: var(--private-bg-color-active, var(--amityeko-color-gray-8));
  }

  sl-button[variant='text'].amityeko-variant-floating[disabled]::part(base) {
    --amityeko-icon-color: var(--private-color-disabled, var(--amityeko-color-gray-8));
    color: var(--private-color-disabled, var(--amityeko-color-gray-8));
  }

  /* Variant: danger */
  sl-button[variant='danger']::part(base) {
    --amityeko-icon-color: var(--amityeko-color-font-light);
    background-color: var(--private-bg-color, var(--amityeko-color-destructive-6));
    color: var(--amityeko-color-font-light);
  }

  sl-button[variant='danger']::part(base):hover {
    background-color: var(--private-bg-color-hover, var(--amityeko-color-destructive-7));
  }

  sl-button[variant='danger']::part(base):active {
    background-color: var(--private-bg-color-active, var(--amityeko-color-destructive-8));
  }

  sl-button[variant='danger'][disabled]::part(base) {
    background-color: var(--private-bg-color-disabled, var(--amityeko-color-destructive-3));
  }
`;
//# sourceMappingURL=styles.js.map